/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon24Regular = forwardRef('MathSumIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4.657 5.347C3.395 4.302 4.135 2.25 5.774 2.25H20a.75.75 0 0 1 0 1.5H5.774a.25.25 0 0 0-.16.442l7.796 6.46a1.75 1.75 0 0 1 0 2.696l-7.796 6.46a.25.25 0 0 0 .16.442H20a.75.75 0 0 1 0 1.5H5.774c-1.64 0-2.379-2.052-1.117-3.098l7.796-6.46a.25.25 0 0 0 0-.385l-7.796-6.46Z" })));
});
